import { apiClient } from "./client";

/**
 * Public: Fetch a published legal document by slug ('terms' or 'privacy').
 * Note: apiClient response interceptor already unpacks response.data.data -> res.data.
 */
export async function fetchPublicLegalDocument(slug) {
  try {
    const res = await apiClient.get(`/legal/${slug}`);
    return res.data ?? null;
  } catch (err) {
    console.warn(`Could not load dynamic legal document for ${slug}:`, err);
    return null;
  }
}

/**
 * Platform Admin: Fetch all legal documents.
 */
export async function fetchAdminLegalDocuments() {
  const res = await apiClient.get("/admin/legal");
  return res.data ?? [];
}

/**
 * Platform Admin: Fetch specific legal document with fallback default template.
 */
export async function fetchAdminLegalDocument(slug) {
  const res = await apiClient.get(`/admin/legal/${slug}`);
  return res.data ?? { document: null, defaultTemplate: null };
}

/**
 * Platform Admin: Fetch default system template for a document.
 */
export async function fetchAdminLegalDefault(slug) {
  const res = await apiClient.get(`/admin/legal/${slug}/default`);
  return res.data ?? null;
}

/**
 * Platform Admin: Update or publish legal document.
 */
export async function updateAdminLegalDocument(slug, payload) {
  const res = await apiClient.put(`/admin/legal/${slug}`, payload);
  return res.data;
}
